export const removeNewLinesAndTabs = (str: string) =>
  str.replace(/(\n|\r|\t)/gm, ' ');
